import { createElement } from "react";
/**
 * External Dependencies
 */
import { css } from 'emotion';
import classnames from 'classnames';
const ArrowIcon = ({
  theme
}) => {
  return createElement("svg", {
    className: classnames('renderer-core-arrow-icon', css`
					fill: ${theme.buttonsFontColor};
				`),
    focusable: "false",
    viewBox: "0 0 24 24",
    "aria-hidden": "true"
  }, createElement("path", {
    d: "M5.88 4.12L13.76 12l-7.88 7.88L8 22l10-10L8 2z"
  }));
};
export default ArrowIcon;
//# sourceMappingURL=arrow-icon.js.map